// extracted by mini-css-extract-plugin
module.exports = {"counter":"DataCounter_counter__e_tnw","description":"DataCounter_description__wxQV_","wrapper":"DataCounter_wrapper__jyb9H"};